import React from 'react'
import '../../App.css'
import AboutCoding from '../AboutCoding';
import Footer from '../Footer';
function Coding(){
    return(
        <>
        <AboutCoding/>
        <Footer />
        </>
    )
}
export default Coding;